import React from 'react';
import { Navigate } from 'react-router-dom';

export const lazy = componentPath => React.lazy(() => import(`@/views/${componentPath}`))
export const cpnsLazy = componentPath => React.lazy(() => import(`@/components/${componentPath}`))
export const Redirect = Navigate